import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'
import { useAsyncCallback } from '../../../../hooks'
import { FilterBar } from '../../../Filter'
import { useTableRefresh } from '../../../Table'
import { useDocFlowContext } from '../useDocFlowContext'

export function useDocFlowPhaseTable({
  TableFilterBar = FilterBar,
  getFilterApi,
  getMassActions,
  items,
  tableLoader,
  updateTableConfig,
}) {
  const { t } = useTranslation()

  const { columns, handleReload, isRefetching } = tableLoader

  const { containerRef, documentId, phaseDisabled } = useDocFlowContext()

  const [isConfigOpen, setConfigOpen] = useState(false)

  const { refreshButtonProps } = useTableRefresh({
    isRefetching,
    onReload: handleReload,
  })

  function handleConfigOpen() {
    setConfigOpen(true)
  }

  const massActions = getMassActions?.(t) || EMPTY_LIST

  const filterApi = TableFilterBar ? getFilterApi(documentId) : null

  const handleUpdateConfig = useAsyncCallback(
    (obj = EMPTY_OBJECT) => {
      return updateTableConfig({
        columns,
        ...obj,
      })
    },
    [columns, updateTableConfig]
  )

  const tableItems = items || tableLoader?.items?.items || EMPTY_LIST

  return {
    containerRef,
    documentId,
    filterApi,
    handleConfigOpen,
    handleUpdateConfig,
    isConfigOpen,
    massActions,
    phaseDisabled,
    refreshButtonProps,
    setConfigOpen,
    tableItems,
  }
}
